export class QrefOgrnModel {
  ogrn: string;

  constructor() {
  }
}

